/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

export type TradingPositionListPositionsStatus =
  (typeof TradingPositionListPositionsStatus)[keyof typeof TradingPositionListPositionsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradingPositionListPositionsStatus = {
  open: 'open',
  closed: 'closed',
  settled: 'settled',
} as const;
